import Phaser from 'phaser'

import tilesUrl from 'url:../assets/tilesets/0x72-industrial-tileset-32px-extruded.png'
import tutorial1MapData from '../assets/tilemaps/tutorial_1.json'
import tutorial2MapData from '../assets/tilemaps/tutorial_2.json'
import tutorial3MapData from '../assets/tilemaps/tutorial_3.json'
import tutorial4MapData from '../assets/tilemaps/tutorial_4.json'
import spikeUrl from 'url:../assets/images/0x72-industrial-spike.png'
import playerUrl from 'url:../assets/spritesheets/0x72-industrial-player-32px-extruded.png'
import track1Url from 'url:../assets/music/Loyalty_Freak_Music_-_02_-_High_Technologic_Beat_Explosion.mp3'

export default class Preloader extends Phaser.Scene
{
    constructor()
    {
        super('preloader')
    }

    preload()
    {
        this.load.image('tiles', tilesUrl)
        this.load.image('spike', spikeUrl)

        this.load.spritesheet(
            'player',
            playerUrl,
            {
              frameWidth: 32,
              frameHeight: 32,
              margin: 1,
              spacing: 2
            }
        )

        this.load.audio('track1', [track1Url])
        
    }

    create()
    {
        this.cache.tilemap.add('tutorial_map_1', { format: Phaser.Tilemaps.Formats.TILED_JSON, data: tutorial1MapData })
        this.cache.tilemap.add('tutorial_map_2', { format: Phaser.Tilemaps.Formats.TILED_JSON, data: tutorial2MapData })
        this.cache.tilemap.add('tutorial_map_3', { format: Phaser.Tilemaps.Formats.TILED_JSON, data: tutorial3MapData })
        this.cache.tilemap.add('tutorial_map_4', { format: Phaser.Tilemaps.Formats.TILED_JSON, data: tutorial4MapData })
        this.scene.start('startScreen')
    }
}